import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import News from "../views/News.vue";
import ServiceEmail from "../views/serviceEmail.vue";
import WMWap from "../views/WMWap.vue";
import Submit from "../views/Submit.vue";
import Faq from "../views/Faq.vue";
import Country from "../views/Country.vue";
import SearchRes from "../views/SearchRes.vue";
import Publish_submit from "../views/Publish_submit.vue";
import About from "../views/About.vue";
import VideoPage from "../views/VideoPage.vue";
import Video from "../views/Video.vue";
import Return_employment from "../views/Return_employment.vue";
import Article from "../views/Article.vue";
import Privacy from "../views/Privacy.vue";
import Website_Security from "../views/Website_Security.vue";
import CopyrightPage from "../views/CopyrightPage.vue";
import ArticlePage from "@/views/ArticleSinglePage.vue";
import Banner from "../components/Home/Banner.vue";
const WinnerList = () => import("@/views/WinnerList.vue");
const Download = () => import("@/views/Download.vue");
const NewsSubscription = () => import("@/views/NewsSubscription.vue");
const FraudSelfCheck = () => import("@/views/FraudSelfCheck.vue");
const FraudNotice = () => import("@/views/FraudNotice.vue");
const FraudNoticeAgency = () => import("@/views/FraudNoticeAgency.vue");
const FraudNoticeComplaint = () =>
  import("@/views/FraudNoticeComplaint.vue");

const routes = [
  //首頁
  {
    path: "/index",
    name: "首頁",
    alias: "/",
    components: { default: Home, Banner },
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
        },
      ],
      title: "國人海外就業資源中心",
    },
  },

  //最新消息
  {
    path: "/news",
    name: "News",
    component: News,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: "最新消息",
        },
      ],
      title: "國人海外就業資源中心-最新消息總覽",
    },
  },

  //最新消息單一頁
  {
    path: "/news/news_page/:pageId",
    name: "News_page",
    component: ArticlePage,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: "最新消息",
          link: "/news",
        },
        // {
        //   name: "最新消息",
        // },
      ],
      title: "國人海外就業資源中心-最新消息內文",
    },
  },

  //國家頁
  {
    path: "/:countryId",
    name: "Country",
    component: Country,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: ":countryName",
        },
      ],
      title: "國人海外就業資源中心-海外國家",
    },
  },

  //網站導覽
  {
    path: "/w.map",
    name: "網站導覽",
    component: WMWap,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: "網站導覽",
        },
      ],
      title: "國人海外就業資源中心-網站導覽",
    },
  },
  //搜尋結果
  {
    path: "/search",
    name: "搜尋結果",
    component: SearchRes,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: "搜尋結果",
        },
      ],
      title: "國人海外就業資源中心-搜尋結果",
    },
  },

  //發表投稿
  {
    path: "/Publish_submit/:countryId",
    name: "發表投稿",
    component: Publish_submit,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: ":countryName",
          link: "/country:countryId",
        },
        {
          name: "發表投稿",
        },
      ],
      title: "國人海外就業資源中心-發表投稿",
    },
  },

  //達人投稿(綜合)
  {
    path: "/submit",
    name: "Submit",
    component: Submit,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: "達人投稿",
        },
      ],
      title: "國人海外就業資源中心-達人投稿文章總覽",
    },
  },

  //達人投稿(單一資訊頁)
  {
    path: "/submit/:pageId",
    name: "SubmitPage",
    component: ArticlePage,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: ":countryName",
          link: "/country:countryId",
        },
        {
          name: "達人投稿",
          link: "/submit",
        },
      ],
      title: "國人海外就業資源中心-達人投稿內文",
    },
  },

  //中心簡介
  {
    path: "/About",
    name: "About",
    component: About,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: "中心簡介",
        },
      ],
      title: "國人海外就業資源中心-中心簡介",
    },
  },

  //常見問答
  {
    path: "/faq",
    name: "常見問答",
    component: Faq,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: "常見問答",
        },
      ],
      title: "國人海外就業資源中心-常見問答",
    },
  },

  //線上問答
  {
    path: "/ServiceEmail",
    name: "聯絡我們",
    component: ServiceEmail,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: "聯絡我們",
        },
      ],
      title: "國人海外就業資源中心-聯絡我們",
    },
  },

  //影音專區(綜合)
  {
    path: "/video",
    name: "Video",
    component: Video,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: "影音專區",
        },
      ],
      title: "國人海外就業資源中心-影音專區總覽",
    },
  },

  //影音專區(單一資訊頁)
  {
    path: "/video/:id",
    name: "VideoInner",
    component: VideoPage,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: ":countryName",
          link: "/country:countryId",
        },
        {
          name: "影音專區",
          link: "/video",
        },
      ],
      title: "國人海外就業資源中心-影音專區內容",
    },
  },

  //海外返國專區
  {
    path: "/return_employment",
    name: "海外返國專區",
    component: Return_employment,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: "海外返國專區",
        },
      ],
      title: "國人海外就業資源中心-海外返國專區總覽",
    },
  },

  //海外返國 - 海外返國就業(單一資訊頁)
  {
    path: "/return_employment/employment/:pageId",
    name: "Employment",
    component: ArticlePage,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: "海外返國專區",
          link: "/return_employment",
        },
      ],
      title: "國人海外就業資源中心-海外返國專區內文",
    },
  },

  //專家建議
  {
    path: "/article",
    name: "Article",
    component: Article,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: "專家建議",
        },
      ],
      title: "國人海外就業資源中心-專家建議總覽",
    },
  },

  //專家建議(單筆)
  {
    path: "/article/:pageId",
    name: "ArticlePage",
    component: ArticlePage,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: ":countryName",
          link: "/country:countryId",
        },
        {
          name: "專家建議",
          link: "/article",
        },
      ],
      title: "國人海外就業資源中心-專家建議內文",
    },
  },

  //著作權聲明
  {
    path: "/CopyrightPage",
    name: "著作權聲明",
    component: CopyrightPage,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: "著作權聲明",
        },
      ],
      title: "國人海外就業資源中心-著作權聲明",
    },
  },
  //著作權聲明
  {
    path: "/Privacy",
    name: "隱私權政策",
    component: Privacy,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: "隱私權政策",
        },
      ],
      title: "國人海外就業資源中心-隱私權政策",
    },
  },
  // 網站安全政策
  {
    path: "/Website_Security",
    name: "網站安全政策",
    component: Website_Security,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: "網站安全政策",
        },
      ],
      title: "國人海外就業資源中心-網站安全政策",
    },
  },
  //得獎名單
  {
    path: "/winner_list",
    name: "winner_list",
    component: WinnerList,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: "得獎名單",
        },
      ],
      title: "得獎名單",
    },
  },
  // 防詐專區 - 海外就業自我檢核
  {
    path: "/fraud_prevention/self_check",
    name: "fraud_prevention_self_check",
    component: FraudSelfCheck,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: "防詐專區",
        },
        {
          name: "海外就業自我檢核",
        },
      ],
      title: "防詐專區-海外就業自我檢核",
      hideBanner: true,
    },
  },
  // 防詐專區 - 打工度假代辦服務應注意事項 / 度假打工遇有我國違(非)法私立就業服務機構申訴資訊
  {
    path: "/fraud_prevention/notice",
    name: "fraud_prevention_notice",
    component: FraudNotice,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: "防詐專區",
        },
        {
          name: "打工度假代辦服務應注意事項",
        },
      ],
      title: "防詐專區-打工度假代辦服務應注意事項",
      hideBanner: true,
    },
  },
  // 防詐專區 - 打工度假代辦服務應注意事項 詳情頁
  {
    path: "/fraud_prevention/notice/agency",
    name: "fraud_prevention_notice_agency",
    component: FraudNoticeAgency,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: "防詐專區",
        },
        {
          name: "打工度假代辦服務應注意事項",
          link: "/fraud_prevention/notice",
        },
        {
          name: "打工度假代辦服務應注意事項",
        },
      ],
      title: "防詐專區-打工度假代辦服務應注意事項",
      hideBanner: true,
    },
  },
  // 防詐專區 - 度假打工遇有我國違(非)法私立就業服務機構申訴資訊 詳情頁
  {
    path: "/fraud_prevention/notice/complaint",
    name: "fraud_prevention_notice_complaint",
    component: FraudNoticeComplaint,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: "防詐專區",
        },
        {
          name: "打工度假代辦服務應注意事項",
          link: "/fraud_prevention/notice",
        },
        {
          name: "度假打工遇有我國違(非)法私立就業服務機構申訴資訊",
        },
      ],
      title: "防詐專區-度假打工遇有我國違(非)法私立就業服務機構申訴資訊",
      hideBanner: true,
    },
  },
  // 下載專區
  {
    path: "/download",
    name: "download",
    component: Download,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: "下載專區",
        },
      ],
      title: "下載專區",
    },
  },
  {
    path: "/news_subscription",
    name: "NewsSubscription",
    component: NewsSubscription,
    meta: {
      breadcrumbList: [
        {
          name: "首頁",
          link: "/index",
        },
        {
          name: "訂閱電子報",
        },
      ],
      title: "訂閱電子報",
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach(() => {
  window.scrollTo(0, 0);
});

// 更改網站標題
router.beforeEach((to) => {
  const title = to.meta.title;
  if (title) {
    document.title = title;
  }
});

export default router;
